import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { css } from '@emotion/react';

import { ReactComponent as LogoIcon } from '../../assets/Logo.svg';
import HeaderBgr from '../../assets/header_bg.png';
import { useThemeContext } from 'contexts/ThemeContext';
import { useAppContext } from 'contexts/AppContext';
import { makeStyles } from "@mui/styles";
import { BsFillBellFill } from 'react-icons/bs'
import { BiLeftArrowAlt } from 'react-icons/bi'
import NotiButton from '../../pages/insurance-car/NotiButton';

import Badge from "@mui/material/Badge";
import { createTheme, ThemeProvider, IconButton, Box, Typography } from "@mui/material";
import { InitState, LocalStorageText } from '../../constants/common.js';
import { loginObservable } from '../../common/observable.js';

const headerStyle = ({ isLight, mainColor, defaultColor }) => css`
 z-index: 1;
  position: sticky;
  background-color: ${mainColor === defaultColor ? 'var(--body-bgr)' : mainColor};
  background-image: ${mainColor === defaultColor ? 'url(' + HeaderBgr + ')' : 'none'};
  background-size: 100%;
  top: 0;
  padding: 0 10px 0 10px;
  color: var(--color-white);
  font-weight: 700;

  & > nav {
    height: 100%;
    display: flex;
    margin: 0px 0px;
    max-width: 480px;
    align-items: center;
    justify-content: flex-start;
    .boxLeft{
			width: 20%;
			display: flex;
			margin-left: 0px;
			justify-content: flex-start;
		}
		.boxRight{
			width: 80%;
			display: flex;
			margin: 0px;
			align-items: center;
			justify-content: flex-end;
		}
	.topRight-btn {
		justify-content: center;
		white-space: pre;
		margin-right: 10px;
		.login-btn{
		
			display: flex;
			align-items: center;
			padding-left: 10px;
		}
	}
	
    .logo1 a {
      height: 100%;
      display: flex;
      align-items: flex-start;
			margin-left: 0px !important;
      //font-weight: bold;
      //text-decoration: none;
      //text-transform: uppercase;

      svg {
        width: 100%;
        height: 32px;

      }
    }

    svg.theme {
      cursor: pointer;
      display: flex;
      user-select: none;
    }
  }
`;

const theme = createTheme({
	components: {
		MuiBadge: {
			styleOverrides: {
				colorError: {
					fontWeight: 700,
					fontSize: 9
				},
				badge: {
					height: 15
				}
			}
		}
	},
	typography: {
		headerLinkName: {
			fontWeight: "normal !important",
			fontSize: "1rem !important",
			marginLeft: "1rem !important",
		}
	},
})


const getRouteName = (pathName, fnol) => {
	const mainPathName = pathName.split('/')[1];
	switch (mainPathName) {
		case 'register':
			return "Đăng ký";
		case 'forgot-password':
			return "Quên mật khẩu";
		case 'contract-detail':
			return "Chi tiết hợp đồng";
		case 'contract-detail-adld':
			return "Chi tiết hợp đồng";
		case 'contract-detail-4-wheel':
			return "Chi tiết hợp đồng bảo hiểm";
		case 'claim-detail':
			return "Chi Tiết Bồi Thường";
		case 'claim-detail-adld':
			return "Chi Tiết Bồi Thường";
		case 'claim-detail-epi':
				return "Chi Tiết Bồi Thường " + fnol;
		case 'ep-claim':
				return "Chi Tiết Bồi Thường " + fnol;
		case 'create-claim':
			return "Tạo yêu cầu bồi thường " + fnol;
		case 'create-claim-momo':
			return "Tạo yêu cầu bồi thường " + fnol;
		case 'create-claim-adld':
			return "Tạo yêu cầu bồi thường " + fnol;
		case 'create-claim-ep':
				return "Tạo yêu cầu bồi thường " + fnol;
		case 'ep-claim-create':
				return "Tạo yêu cầu bồi thường " + fnol;
		case 'claim-info':
			return "Thông Tin Bồi Thường " + fnol;
		case 'claim-info-momo':
			return "Thông Tin Bồi Thường " + fnol;
		case 'claim-info-adld':
			return "Thông Tin Bồi Thường " + fnol;
		case 'claim-info-ep':
			return "Thông Tin Bồi Thường " + fnol;
		case 'ep-claim-info':
			return "Thông Tin Bồi Thường " + fnol;
		case 'claim-momo':
			return "Chi Tiết Bồi Thường " + fnol;
		case 'claim-guide':
			return "Hướng dẫn gửi yêu cầu bồi thường";
		case 'claim-guide-adld':
			return "Hướng dẫn gửi yêu cầu bồi thường";
		case 'claim-2-wheel-guide':
			return "Hướng dẫn gửi yêu cầu bồi thường";
		case 'claim-4-wheel-guide':
			return "Hướng dẫn gửi yêu cầu bồi thường";
		case 'claim-guide-ep':
				return "Hướng dẫn gửi yêu cầu bồi thường";
		case 'confirm-email':
			return "Xác Thực Email";
		case 'verify-email':
			return "Xác Thực Email";
		case 'user-info':
			return "Thông tin cá nhân";
		case 'password':
			return "Mật khẩu";
		case 'notification':
			return "Thông Báo";
		case 'benefits':
			return "Quyền lợi bảo hiểm";
		case 'benefits-adld':
			return "Quyền lợi bảo hiểm";
		case 'benefits-2-wheel':
			return "Quyền lợi bảo hiểm";
		case 'benefits-4-wheel':
			return "Quyền lợi bảo hiểm";
		case 'benefits-ep':
				return "Quyền lợi bảo hiểm";
		case 'qna':
			return "Hỏi Và Đáp";
		case 'change-password':
			return "Quên Mật Khẩu";
		case 'contract-2-wheel-detail':
			return "Chi tiết hợp đồng xe máy " + fnol;
		case '2wheel-claim-momo':
			return "Chi Tiết Bồi Thường " + fnol;
		case 'create-claim-2-wheel':
			return "Tạo yêu cầu bồi thường " + fnol;
		case 'create-2-wheel-claim-momo':
			return "Tạo yêu cầu bồi thường " + fnol;
		case 'claim-detail-ybb':
			return "Chi Tiết Bồi Thường " + fnol;
		case 'claim-2-wheel-info':
			return "Thông Tin Bồi Thường " + fnol;
		case 'claim-2-wheel-info-momo':
			return "Thông Tin Bồi Thường " + fnol;
		case 'create-claim-4-wheel':
			return "Tạo yêu cầu bồi thường " + fnol;
		case 'upload-license':
			if (pathName.split('/')[2] == 'add') {
				return "Thông tin chứng từ " + fnol;
			} else {
				return "Thông tin chứng từ " + fnol;
			}
		case 'upload-license-momo':
			return "Thông tin chứng từ " + fnol;
		case 'upload-license-ep':
				return "Thông tin chứng từ " + fnol;
		case 'ep-claim-upload-license':
				return "Thông tin chứng từ " + fnol;
		case 'verify-sms':
			return "Xác Thực OTP";
		case 'verify-sms-momo':
			return "Xác Thực OTP";
		case 'claim-detail-yab':
			return "Chi tiết yêu cầu bồi thường " + fnol;
		case 'upload-license-4-wheel':
			return "Chứng từ " + fnol;
		case 'claim-4-wheel-info':
			return "Thông Tin Bồi Thường " + fnol;
		case '4wheel-claim':
			return "Chi tiết yêu cầu bồi thường " + fnol;
		case '4wheel-claim-info-momo':
			return "Thông Tin Bồi Thường " + fnol;
		case '4wheel-claim-upload-license-momo':
			return "Chứng từ " + fnol;
		case '4wheel-claim-create-mono':
			return "Tạo yêu cầu bồi thường " + fnol;
		case 'contract-detail-ep':
				return "Chi tiết hợp đồng " + fnol;
		default:
			return null;
	}
}
const isHideBackBtn = (pathName) => {
	const mainPathName = pathName.split('/')[1];
	if (mainPathName === "claim-momo") {
		return true
	}
	if (mainPathName === "ep-claim") {
		return true
	}
	if (mainPathName === "4wheel-claim") {
		return true
	}
	if (mainPathName === "upload-license-4-wheel" || mainPathName === "4wheel-claim-upload-license-momo") {
		if (pathName.split('/')[2] == 'add') {
			return true;
		} else {
			return false;
		}
	}
	if (mainPathName === "upload-license") {
		if (pathName.split('/')[2] == 'add') {
			return true;
		} else {
			return false;
		}
	}
	if (mainPathName === "upload-license-momo") {
		if (pathName.split('/')[2] == 'add') {
			return true;
		} else {
			return false;
		}
	}
	if (mainPathName === "create-2-wheel-claim-momo" || mainPathName === "4wheel-claim-create-mono") {
		return true
	}
	if (mainPathName === "2wheel-claim-momo") {
		return true
	}
	if(mainPathName === "claim-detail-yab"){
		return true;
	}
	if(mainPathName === "claim-detail-ybb"){
		return true;
	}
	return false
}

const Header = ({ loginSuccess }) => {
	const location = useLocation();
	const navigate = useNavigate();
	const { isLight, toggleTheme, mainColor, defaultColor } = useThemeContext();
	const { fnol } = useAppContext();
	const token = localStorage.getItem(LocalStorageText.Token);
	const [authenticated, setAuthenticated] = useState(token && token !== InitState)

	useEffect(() => {
		loginObservable.subscribe((value) => {
			setAuthenticated(value && value !== InitState)
		})
	}, []);

	return (
		<ThemeProvider theme={theme}>
			<header css={[headerStyle({ isLight, mainColor, defaultColor })]} style={authenticated ? { height: 60 } : {}}>
				{getRouteName(location.pathname) ?
					<nav>
						<Box
							sx={{
								display: 'flex',
								alignItems: 'center',
								my: isHideBackBtn(location.pathname) ? 1 : 0
							}}
						>
							{!isHideBackBtn(location.pathname) && <IconButton onClick={() => navigate(-1)}>
								<BiLeftArrowAlt size={32} color="white" />
							</IconButton>}
							<Typography variant="headerLinkName">{getRouteName(location.pathname, fnol)}</Typography>
						</Box>
					</nav>
					: loginSuccess
						? <nav style={{ width: "100%" }}>
							<div className={"boxLeft"}>
								<div className="logo1">
									<Link to="/" replace={location.pathname === '/'}>
										<LogoIcon fill="white"/>
									</Link>
								</div>
							</div>
							<div className={"boxRight"}>

								<div className={"topRight-btn"}>
									{!authenticated &&
										<div className={"login-btn"}>
											<NotiButton/>
											{/*<RiLock2Line size={16} />*/}
											{/*<a>Đăng nhập</a>*/}
										</div>
									}
									{
										authenticated &&
										<div className={"login-btn"}>
											{/* <Link to="/notification" replace={location.pathname === '/notification'}> */}
											<NotiButton/>
											{/* </Link> */}
											{/*<RiLock2Line size={16} />*/}
											{/*<a>Đăng nhập</a>*/}
										</div>
									}
								</div>
							</div>
						</nav>
						: ""}
			</header>
		</ThemeProvider>
	);
};

export default Header;
